import { AxiosError } from "axios";
import { useToast } from "vue-toastification";
const toast = useToast();

export function toastError(error: AxiosError): void {
  const message = error?.response?.data?.message;

  toast.error(message || "Something went wrong");
}
